angular
    .module('cabinetApp')
    .controller('widgetsCTRL', function widgetsCTRL($scope, $rootScope, $state, $timeout, widgetsModel, accrualsModel, newsModel, utilities, $http) {
        $scope['showNotice']          = false;
        $scope['balance']             = null;
        $scope['pageName']            = '';
        $scope['mapsType']            = '';
        $scope['newsList']            = [];
        $scope['lastNews']            = [];
        $scope['meterList']           = [];
        $scope['creditList']          = [];
        $scope['userSectors']         = [];
        $scope['rqParams']            = {};
        $scope['saldoItem']           = {};
        $scope['providerInfo']        = {};
        $scope['requestChart']        = {};
        $scope['newsParams']          = {};
        $scope['newsParams']['types'] = [];
        $scope['rqParams']['from']           = new Date(utilities.getDate('12'));
        $scope['rqParams']['till']           = utilities.getTodayDate();
        $scope['rqParams']['sectorSelected'] = true;
        $scope['newsParams']['typeSelected'] = true;

        // Список непрочитанных новостей + новости для виджета
        $scope.getUnreadNews = function() {
            //return;
            newsModel.getUnreadNewsV4(function(news, widgetNews) {
                $scope['lastNews'] = news;
                $scope['newsList']    = widgetNews;

                if (news.length) {
                    $scope.readNews(0, 'lastNews');
                }
            });
        };

        // Данные управляющей компании
        $scope.getProviderInfo = function() {
            $scope['providerInfo']['contacts'] = [];
            $scope['providerInfo']['name']     = $rootScope['user']['info']['provider']['str_name'];
            $scope['providerInfo']['address']  = $rootScope['user']['info']['_extra']['provider']['address']['real'];
            if($rootScope['user']['info']['_extra']['provider']['address']['real']['point']){
                $scope['providerInfo']['markers']  = $rootScope['user']['info']['_extra']['provider']['address']['real']['point']['coordinates'];
                $scope['providerInfo']['location'] = $rootScope['user']['info']['_extra']['provider']['address']['real']['point']['coordinates'].reverse();
            }

            $rootScope['user']['info']['_extra']['provider']['phones'].forEach(function(item) {
                var result = {};
                    result['type']  = utilities.getValueFromDictionary($rootScope['dictionaries']['Phone']['TYPE'], 'value', item['type'], 'text');
                    result['href']  = '+7' + item['code'] + item['number'];
                    result['phone'] = '+7' + ' (' + item['code'] + ') ' + item['number'];

                item['add'] ? result['phone'] += ' Добавочный ' + item['add'] : '';

                $scope['providerInfo']['contacts'].push(result);
            });
        };

        // Установка пользовательских направлений
        $scope.setSectors = function() {
            $rootScope['dictionaries']['sectors'].forEach(function(item) {
                $scope['userSectors'].push({
                    value : item,
                    text  : utilities.getValueFromDictionary($rootScope['dictionaries']['AccrualsSectorType'], 'value', item, 'text')
                });

                $scope['rqParams'][item] = true;
            });
        };

        // Установка типов новостей
        $scope.setNewsTypes = function() {
            if ($scope['newsParams']['types'].length < 1) {
                $rootScope['dictionaries']['News']['SystemCategory'].forEach(function(item) {
                    $scope['newsParams']['types'].push({
                        type   : item['value'],
                        name   : item['text'],
                        active : true
                    });
                });
            }
        };

        // Данные для виджетов
        $scope.getData = function() {
            var value  = 0;
            var params = {};
                params['sectors']    = $rootScope['dictionaries']['sectors'];
                //params['news_limit'] = $rootScope['userSettings']['userNews']['value'];

            widgetsModel.getData(params, function(response) {
                $scope['requestChart'] = {};
                $scope['requestChart']['labels'] = [];
                $scope['requestChart']['data']   = [];
                $scope['requestChart']['colors'] = [];

                var state = $rootScope.user.info.settings.sber_auto_pay;
                //$scope['newsList']    = response['news'];
                $scope['creditList']  = response['debts'];
                if(state && state.length){
                    state.forEach(function(sec){
                        $scope.creditList.forEach(function(item){
                            if(item.sector === sec.sector){
                                item.state = sec.state;
                            }
                        });
                    });
                }
                $scope['meterList']   = response['meters'];

                $scope['meterList'].forEach(function(item) {
                    item['type']    = utilities.getValueFromDictionary($rootScope['dictionaries']['AreaMeter']['_SUBTYPES'], 'value', item['_type'][0], 'short_name');
                    item['name']    = item['serial_number'];
                });

                $scope['creditList'].forEach(function(item) {
                    value += item.debt;

                    item['status']  = utilities.getValueFromDictionary($rootScope['constants']['balanceValues'], 'value', item.debt < 0, 'text');
                    item['text']    = utilities.getValueFromDictionary($rootScope['dictionaries']['AccrualsSectorType'], 'value', item.sector, 'text');
                    item['value']   = utilities.formatNumber(Math.abs(item.debt), 2, ' ');
                    item['number']  = item.debt;
                });

                $rootScope['constants']['requestTypes'].forEach(function(item) {
                    var value = response['requests']['own'];

                    if (item['value'] === 'true') {
                        value = response['requests']['house'];
                    }

                    $scope['requestChart']['labels'].push(item['chartStatus']);
                    $scope['requestChart']['colors'].push(item['color']);
                    $scope['requestChart']['data'].push(value);

                });

                $scope['saldoItem']['number']    = value;
                $scope['saldoItem']['value']     = utilities.formatNumber(Math.abs(value), 2, ' ');
                $scope['saldoItem']['type']      = utilities.getValueFromDictionary($rootScope['constants']['balanceTypes'], 'value', value > 0, 'text');
                $scope['showNotice'] = response['meters'].length || value > 0;
            });
        };

        // Открыть окно новости
        $scope.readNews = function(index, type) {
            var data = {};
                data['name']  = $scope[type][index]['subject'];
                data['text']  = $scope[type][index]['body'];
                data['files'] = $scope[type][index]['files'];
                data['index'] = index;
                data['prev']  = index > 0;
                data['next']  = index < $scope[type].length - 1;
                data['from']  = type;
                data['page']  = 'widgets';
                data['id'] = $scope[type][index]['_id'];

            utilities.openWindow('news', data);
        };

        /* Подключение автоплатежа */
        $scope.setAutoPay = function(index){
            return $http.post('/api/v4/forms/tenant/sber_auto_pay/',
                {sector: $scope.creditList[index].sector})
                .then(function(response){
                    $rootScope.$broadcast('reloadUserInfo');
                    alert('Ваша заявка на подключение услуги "Автоплатеж" принята. Ожидайте дальнейшие инструкции на электронную почту');
                });
        };

        /* Получить список сохраненных карт */
        $scope.getAutoPaySettings = function() {
            return $http.get('/api/v4/billing/tenant/pay_settings/').then(function(response){
                var data = response.data.results || [];
                $rootScope.autoPaySettings = {};
                var sectors = [];
                if(data.length){
                    sectors = _.uniq(_.pluck(data, 'sector'));
                }
                sectors.forEach(function(sector){
                    var autoPay = null;
                    var fastPay = [];
                    data.forEach(function(setting){
                        if(setting.sector === sector){
                            fastPay.push(setting);
                            if(setting.auto_pay){
                                autoPay = setting;
                            }
                        }
                    });
                    $rootScope.autoPaySettings[sector] = {
                        autoPay: autoPay, // Карта для автоплатежа и его наличие
                        fastPay: fastPay // Карты для быстрых платежей
                    }
                });
                $rootScope.autoPaySettings.tenantId = $rootScope.userId;
                setTimeout(function(){
                    $rootScope.$apply();
                });
            });
        };

        $scope.$on('getAutoPaySettings', function(){
            $scope.getAutoPaySettings();
        });

        $scope.disableAutoPay = function(sector){
            $rootScope.$broadcast('disableAutoPay', {setting: $scope.autoPaySettings[sector].autoPay});
        };

        //$scope.getBankCards();
        //$scope.getBankCards();
        //$scope.addBankCard().then($scope.getBankCards);

        // $scope.makeAutoPay = function(sector, card, amount){
        //     var data = {
        //         sector: sector,
        //         card: card,
        //         amount: amount
        //     };
        //     return $http.post('/api/v4/billing/tenant/fast_transaction/', data).then(function(response){
        //         $rootScope.$broadcast('getAutoPaySettings');
        //     });
        // };
        //
        // $scope.createNewSetting = function(sector, wantAutoPay, cardNumber){
        //     var data = {
        //         sector: sector,
        //         auto_pay: wantAutoPay,
        //         card: cardNumber
        //     };
        //     return $http.post('/api/v4/billing/tenant/pay_settings/', data);
        // };
        //
        // $scope.$on('paymentModalOpened', function(event, data){
        //     $scope.currSettings = Object.assign({}, $rootScope.autoPaySettings[data.sector]);
        //     $scope.currSettings.sector = data.sector;
        //     $rootScope.currentCard = {
        //         number: ''
        //     };
        //     $scope.haveAutoPay = !_.isEmpty($scope.currSettings.autoPay);
        //     $scope.haveCards = $scope.currSettings.fastPay && $scope.currSettings.fastPay.length;
        //     $rootScope.wishes = {
        //         autoPay: false,
        //         saveCard: false
        //     };
        //     if($scope.haveAutoPay){
        //         $rootScope.currentCard.number = $scope.currSettings.autoPay.card;
        //     }
        // });
        //
        // // Команда открыть окно
        // $rootScope.$on('openWindow', function(event, params) {
        //     $timeout(function() {
        //         $scope['pageId']  = params['data']['page'];
        //         $scope['windows'] = params['data'];
        //         $scope['windows']['type'] = params['windowName'];
        //         $scope['windows']['show'] = true;
        //     }, 100);
        // });

        /* Автоплатёж из бокового виджета */
        $scope.makeWidgetAutoPay = function (index) {
            var accrual = $scope['creditList'][index];
            var data    = {};
            var params  = {};
            params['sector_code'] = accrual['sector'];
            $rootScope.$broadcast('paymentModalOpened', {sector: accrual['sector']});

            utilities.loader(true);
            accrualsModel.getPaymentInfo(params, function(response) {
                data['recipient'] = {};
                data['info']      = {};
                data['bank']      = {};
                data['meta']      = {};
                if (response) {
                    data['meta']['showMessage'] = false;
                    data['recipient']['name']    = response['provider_name'];
                    data['recipient']['inn']     = response['inn'];
                    data['recipient']['account'] = response['bank_account'];
                    data['recipient']['payer']   = $scope.user.info.short_name;
                    data['recipient']['cabinet'] = $scope.user.info.number;
                    data['recipient']['date']    = response['description'];
                    data['recipient']['value']   = accrual['debt'] > 0 ? accrual['debt'] : 0;
                    data['bank']['name']         = response['bank_name'];
                    data['bank']['bic']          = response['bic'][0];
                    data['bank']['ksnp']         = response['correspondent'];
                    data['bank']['checking']     = response['bank_number'];
                    data['bank']['account']      = response['bank_number'];
                    //              data['info']['phones']       = response['phones'];
                    data['info']['email']        = response['email'];
                    data['meta']['provider']     = response['provider_id'];
                    data['meta']['sector']       = params['sector_code'];
                    data['meta']['sectorText']   = params['sector_code'] ? utilities.getValueFromDictionary($rootScope['dictionaries']['AccrualsSectorType'], 'value', params['sector_code'], 'text') : false;
                    data['meta']['accrualId']    = response['accrual'];
                    data['meta']['docId']        = response['doc'];
                } else {
                    data['meta']['showMessage'] = true;
                }
                data['meta']['page']         = 'widgets';

                utilities.loader(false);
                utilities.openWindow('autopayment', data);

                // $scope.wishes.autoPay = true;
                // var window = Object.assign({}, data);
                //
                // if($scope.wishes.autoPay && $scope.currentCard.number) {
                //     //Когда есть карта
                //     $scope.createNewSetting(
                //         $scope.currSettings.sector,
                //         $scope.wishes.autoPay,
                //         $scope.currentCard.number
                //     )
                // } else {
                //     if($scope.wishes.saveCard || $scope.currentCard.number === '') {
                //         // Либо подключается автоплатеж, либо сохраняется/добавляется карта
                //         $scope.createNewSetting(
                //             $scope.currSettings.sector,
                //             $scope.wishes.autoPay,
                //             ''
                //         ).then(function(response) {
                //             $rootScope.$emit(window['meta']['page'] + 'PaymentSend', window);
                //         })
                //     } else {
                //         $rootScope.$emit(window['meta']['page'] + 'PaymentSend', window);
                //     }
                // }
            }, function() {
                data['meta']['showMessage'] = true;

                utilities.loader(false);
                utilities.openWindow('autopayment', data);

                // $scope.wishes.autoPay = true;
                // var window = Object.assign({}, data);
                // if($scope.wishes.autoPay && $scope.currentCard.number) {
                //     //Когда есть карта
                //     $scope.createNewSetting(
                //         $scope.currSettings.sector,
                //         $scope.wishes.autoPay,
                //         $scope.currentCard.number
                //     )
                // } else {
                //     if($scope.wishes.saveCard || $scope.currentCard.number === '') {
                //         // Либо подключается автоплатеж, либо сохраняется/добавляется карта
                //         $scope.createNewSetting(
                //             $scope.currSettings.sector,
                //             $scope.wishes.autoPay,
                //             ''
                //         ).then(function(response){
                //             $rootScope.$emit('accrualsPaymentSend', window);
                //         })
                //     } else {
                //         $rootScope.$emit('accrualsPaymentSend', window);
                //     }
                // }
            })
        };

        // Открыть окно оплаты
        $scope.balancePay = function(index) {
            var accrual = $scope['creditList'][index];
            var data    = {};
            var params  = {};
                params['sector_code'] = accrual['sector'];

            $rootScope.$broadcast('paymentModalOpened', {sector: accrual['sector']});

            utilities.loader(true);
            accrualsModel.getPaymentInfo(params, function(response) {
                utilities.loader();

                data['recipient'] = {};
                data['info']      = {};
                data['bank']      = {};
                data['meta']      = {};
                if (response) {
                    data['meta']['showMessage'] = false;
                    data['recipient']['name']    = response['provider_name'];
                    data['recipient']['inn']     = response['inn'];
                    data['recipient']['account'] = response['bank_account'];
                    data['recipient']['payer']   = $scope.user.info.short_name;
                    data['recipient']['cabinet'] = $scope.user.info.number;
                    data['recipient']['date']    = response['description'];
                    data['recipient']['value']   = accrual['debt'] > 0 ? accrual['debt'] : 0;
                    data['bank']['name']         = response['bank_name'];
                    data['bank']['bic']          = response['bic'][0];
                    data['bank']['ksnp']         = response['correspondent'];
                    data['bank']['checking']     = response['bank_number'];
                    data['bank']['account']      = response['bank_number'];
    //              data['info']['phones']       = response['phones'];
                    data['info']['email']        = response['email'];
                    data['meta']['provider']     = response['provider_id'];
                    data['meta']['sector']       = params['sector_code'];
                    data['meta']['sectorText']   = params['sector_code'] ? utilities.getValueFromDictionary($rootScope['dictionaries']['AccrualsSectorType'], 'value', params['sector_code'], 'text') : false;
                    data['meta']['accrualId']    = response['accrual'];
                    data['meta']['docId']        = response['doc'];
                } else {
                    data['meta']['showMessage'] = true;
                }
                data['meta']['page']         = 'widgets';

                utilities.openWindow('payment', data);
            }, function() {
                data['meta']['showMessage'] = true;

                utilities.openWindow('payment', data);
            });
        };

        // Открыть модалку новой заявки
        $scope.newRequest = function() {
            utilities.openWindow('request', {});
        };

        // Открыть модалку нового обращения
        $scope.newTicket = function() {
            utilities.openWindow('tickets', {});
        };

        // Обновить название текущей страницы
        $scope.updatePageName = function() {
            $timeout(function() {
                $scope['pageName'] = $state['current']['name'];
            }, 100);
        };

        // Кнопка оплатить / отправить в окне оплаты
        $rootScope.$on('widgetsPaymentSend', function(event, data) {
            var params = {};

            if (! data['meta']['showMessage'] && (data['recipient']['value'].toString().trim().length === 0 || parseFloat(data['recipient']['value']).toFixed(2) === '0.00')) {
                utilities.message('Указана некорректная сумма');
            } else if (! data['meta']['showMessage']) {
                params['sector_code'] = data['meta']['sector'];
                params['value']       = parseFloat(data['recipient']['value']);
                params['accrual']     = data['meta']['accrual'];
                params['doc']         = data['meta']['docId'];
                params['auto_pay']    = true;

                accrualsModel.getTransactionInfo(params, function(response) {
                    var data = response['data'];
                    var form = $('#paymentForm');

                    Object.keys(data).forEach(function(item) {
                        form.append('<input type="hidden" name="' + item + '" value="' + data[item] + '">');
                    });

                    //form.attr('action', response['data']['bank_url']);
                    window.open(response.data.bank_url, '_self')
                    //form.submit();
                }, function(response) {
                    try {
                        utilities.message(response['data']['messages'][0]['text']);
                    } catch(e) {
                        console.log(e.text);
                    }
                });
            } else {
                params['account']  = $rootScope['userId'];
                params['provider'] = data['meta']['provider'];

                accrualsModel.setPaymentInLK(params, function() {
                    utilities.message('Запрос отправлен. Повторите попытку оплаты через несколько дней', 'info');
                });
            }
        });

        // Пометить прочитанным новость
        $rootScope.$on('widgetsMarkReadNews', function(event, data) {
            var id = $scope['lastNews'][data['index']]['_id'];
            newsModel.markReadNewsV4(id);
        });

        // Переключение новостей
        $rootScope.$on('widgetsChangeNews', function(event, params) {
            var newIndex = params['index'] + 1;

            if (params['type'] === 'prev') {
                newIndex = params['index'] - 1;
            }

            if (newIndex < $scope[params['from']].length) {
                $scope.readNews(newIndex, params['from']);
            }
        });

        // Начисления и оплаты. Изменение направлений
        $scope.checkParamsForm = function() {
            var result = false;

            $scope['userSectors'].forEach(function(item) {
                if ($scope['rqParams'][item['value']]) {
                    result = true;
                }
            });

            $scope['rqParams']['sectorSelected'] = result;
        };

        // Начисления и оплаты. Применить фильтр
        $scope.applyFilter = function() {
            var data = {};
                data['from']    = utilities.getStartDayIso($scope['rqParams']['from']);
                data['till']    = utilities.getStartDayIso($scope['rqParams']['till']);
                data['sectors'] = [];

            $scope['userSectors'].forEach(function(item) {
                if ($scope['rqParams'][item['value']]) {
                    data['sectors'].push(item['value']);
                }
            });

            $rootScope.$broadcast($scope['pageName'].split('.')[1] + 'UpdateData', data);
        };

        // Новости. Применить фильтр
        $scope.applyNewsFilter = function () {
            var data = [];

            $scope['newsParams']['types'].forEach(function(item) {
                if (item['active']) {
                    data.push(item['type'])
                }
            });

            if (data.length === $scope['newsParams']['types'].length) {
                data = [];
            }

            $rootScope.$broadcast('newsUpdateData', data);
        };

        // Новости. Изменение фильтров
        $scope.checkNewsParamsForm = function() {
            var result = false;

            $scope['newsParams']['types'].forEach(function(item) {
                if (item['active']) {
                    result = true;
                }
            });

            $scope['newsParams']['typeSelected'] = result;
        };

        // Обновление параметров
        $rootScope.$on('updateWidgets', function() {
            $scope.getData();
        });

        // Переход по страницам
        $rootScope.$on('widgetsChangeItems', function() {
            $scope.updatePageName();
        });

        // Отслеживание получения пользовательской ифнормации
        $rootScope.$watch('user.info.accounts', function(data) {
            if (! $.isEmptyObject(data)) {
                $scope.getProviderInfo();
                $scope.getUnreadNews();
                $scope.getData();
                $scope.setSectors();
                $scope.setNewsTypes();
            }
        });
        $scope.getAutoPaySettings();
        $scope.updatePageName();
    });
